import bookedup from "../images/projects/BookedUp.png";
import emojipedia from "../images/projects/Emojipedia.png";
import hoobank from "../images/projects/HooBank.png";
import aventek from "../images/projects/Aventek.png";
import tripadvisor from "../images/projects/TripAdvisor.png";


export const projects = [
    {
        id: 1,
        name: "BookedUp",
        link: "https://aishwaryaparab.github.io/bookedup/",
        img: bookedup,
        category: "frontend"
    },
    {
        id: 2,
        name: "Emojipedia",
        link: "https://aishwaryaparab.github.io/Emojipedia/",
        img: emojipedia,
        category: "frontend"
    },
    {
        id: 3,
        name: "HooBank",
        link: "https://aishwaryaparab.github.io/HooBank/",
        img: hoobank,
        category: "frontend"
    },
    {
        id: 4,
        name: "Aventek",
        link: "https://aventek.netlify.app/",
        img: aventek,
        category: "frontend"
    },
    {
        id: 5,
        name: "TravelAdvisor",
        link: "https://aishwaryaparab.github.io/Travel-Advisor/",
        img: tripadvisor,
        category: "backend"
    },
    {
        id: 6,
        name: "BookedUp",
        link: "https://aishwaryaparab.github.io/bookedup/",
        img: {bookedup},
        category: "backend"
    }
]